import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { on } from 'process';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllPdfsList(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Pdf,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdPdf(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Pdf,
    }, id);
    return await firstValueFrom(observable);
  }

  async createPdf(pdfTitle: string, title?: string, titleDescription?: string, description?: string, footer?: string, files?: File[]) {
    const formData = new FormData();
    // Append form fields to FormData
    formData.append('pdfTitle', pdfTitle);
    formData.append('title', title);
    formData.append('titleDescription', titleDescription);
    formData.append('description', description);
    formData.append('footer', footer);
    if (files && files.length) {
      files.forEach((file, index) => {
        formData.append('formFiles', file, file.name || `file${index}`);
      });
    }
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Pdf
    }, formData);
    return await firstValueFrom(observable);
  }

  async updatePdf(id, pdfTitle: string, title?: string, titleDescription?: string, description?: string, footer?: string, files?: File[], removeImage: boolean = false) {
    const formData = new FormData();
    formData.append('id', id);
    // Append form fields to FormData
    formData.append('pdfTitle', pdfTitle);
    formData.append('title', title);
    formData.append('titleDescription', titleDescription);
    formData.append('description', description);
    formData.append('footer', footer);
    formData.append('removeImage', removeImage.toString());
    if (files && files.length) {
      files.forEach((file, index) => {
        formData.append('formFiles', file, file.name || `file${index}`);
      });
    }
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Pdf
    }, formData);
    return await firstValueFrom(observable);
  }

  async sendPdf(title, description, email, files?: Blob[]) {
    const formData = new FormData();
    //formData.append('Title', title);
    //formData.append('Description', description);
    formData.append('Email', email);
    if (files && files.length > 0) {
      files.forEach((file, index) => {
        console.log(file);
        console.log(index);
        formData.append('FormFiles', file, `teklif.pdf`);
      });
    }
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Pdf,
      action: "SendPdf"
    }, formData);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
